module.exports = __webpack_public_path__ + "media/paws/paws-top-right-d3e23603.svg";